import React from 'react';
import MessageCenter from '../components/MessageCenter';

const Messages = () => {
  return <MessageCenter />;
};

export default Messages;